document.addEventListener("DOMContentLoaded", function () {
    const sliderEntries = document.querySelectorAll(".fw-slider-entry");
    const indicators = document.querySelectorAll(".fw-indicator-progress");
    if (!sliderEntries || sliderEntries.length === 0) {
        alert("No slider entries found");
        return;
    }

    const entryDurations = Array.from(sliderEntries).map((entry) =>
        parseInt(entry.getAttribute("data-duration") * 1000 || "5000", 10)
    );

    let currentIndex = 0;
    let intervalId;
    let progressIntervalId;

    const showEntry = (index) => {
        Array.from(sliderEntries).forEach((entry, i) => {
            entry.style.display = i === index ? "block" : "none";
        });

        // Reset all indicator progress bars
        indicators.forEach((indicator, i) => {
            indicator.style.width = i === index ? "0%" : "0%";
        });
    };

    const updateIndicator = (index, duration) => {
        const indicator = indicators[index];
        let progress = 0;

        // Clear any existing progress animation
        if (progressIntervalId) clearInterval(progressIntervalId);

        progressIntervalId = setInterval(() => {
            progress += 100 / (duration / 100); // Increment percentage
            indicator.style.width = `${Math.min(progress, 100)}%`;

            if (progress >= 100) clearInterval(progressIntervalId);
        }, 100);
    };

    const startSlider = () => {
        showEntry(currentIndex);
        updateIndicator(currentIndex, entryDurations[currentIndex]);

        if (intervalId) clearInterval(intervalId);

        intervalId = setInterval(() => {
            currentIndex = (currentIndex + 1) % sliderEntries.length;
            startSlider();
        }, entryDurations[currentIndex]);
    };

    // Add click event for indicators
    indicators.forEach((indicator, index) => {
        indicator.parentElement.addEventListener("click", () => {
            clearInterval(intervalId);
            clearInterval(progressIntervalId);
            currentIndex = index;
            startSlider();
        });
    });

    // Start the slider
    startSlider();
});
